module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-duedate-year-2024-a542b875a8834b8272893e5b57a31450.svg";